import * as React from "react";
import { Separator } from "@/components/ui/separator";
export default function TextContent() {
  return <section data-section-id="150772" id="text" className="bg-background text-foreground py-[120px]">
      <div className="mx-auto max-w-3xl px-6 md:px-8">
        <Separator className="mb-16 bg-border opacity-50" />
        
        <h2 className="mb-10 tracking-tight text-primary !font-sans !font-medium text-4xl md:text-6xl w-full md:w-[500px] text-center md:text-left">INTELLIGENZA ARTIFICIALE (AI)</h2>
        
        <div className="font-sans text-lg leading-[1.6] space-y-8 text-muted-foreground">
          <p className="!text-justify">DCLegal offre consulenza all’avanguardia anche in materia di Intelligenza Artificiale, aiutando le aziende a cogliere le opportunità offerte dalle nuove tecnologie nel rispetto della normativa vigente. Supportiamo i nostri clienti nell’analisi dei rischi e nella predisposizione di policy, procedure e valutazioni di impatto specifiche per sistemi di AI, garantendo un approccio etico e conforme all’evoluzione normativa europea.</p>
          
          
          
          
        </div>
      </div>
    </section>;
}